import React from 'react'
import { Route } from 'react-router-dom'
import EmailVerification from './EmailVerification'

import { emailVerification } from "../../../constants/routePaths"

const EmailVerificationRoute = [
  <Route
    key="EmailVerifySuccess"
    exact path={emailVerification}
    component={EmailVerification}
  />,
];

export default EmailVerificationRoute
